import * as Sentry from "@sentry/react";
import { Button } from "@mui/material";

export function throwSentryTestError() {
  Sentry.logger.info("User triggered test log", { log_source: "sentry_test" });
  throw new Error("Sentry test error");
}

export function shouldRenderSentryTestButton() {
  if (process.env.NODE_ENV !== "production") {
    return true;
  }

  if (typeof window === "undefined") {
    return false;
  }

  return new URLSearchParams(window.location.search).get("sentryTestButton") === "1";
}

export default function SentryTestButton() {
  return (
    <Button
      variant="contained"
      color="error"
      onClick={throwSentryTestError}
      sx={{
        display: { xs: "none", sm: "inline-flex" },
        position: "fixed",
        right: 16,
        bottom: 16,
        zIndex: 1500,
        boxShadow: "0 8px 20px rgba(127, 29, 29, 0.2)",
      }}
    >
      Trigger Sentry Test Error
    </Button>
  );
}
